module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HoldingAlbum-f48ba0fe9fa38c120c51e799305c88b0.jpg";